import DIApi from './_diApi';

class PurchasePurposeAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'PurchasePurposes';
}

export default new PurchasePurposeAPI();
